module.exports = __webpack_public_path__ + "img/econsult.c08c0d50.svg";